/**
 * Utility functions extracted from ArchiveElement.tsx
 */

interface ArchiveItem {
  contentType?: {
    image?: {
      formats?: {
        small?: { url: string };
        thumbnail?: { url: string };
      };
    };
  };
}

/**
 * Extracts image URL preferring small then thumbnail format
 */
/**
 * Type guard: checks if the item is a document entity (has 'file' in attributes)
 */
export const isDocumentEntity = (
  item: Record<string, unknown>
): boolean => {
  return "file" in item;
};

/**
 * Extracts image URL preferring small then thumbnail format
 */
export const getImageUrl = (item: ArchiveItem): string => {
  if (item.contentType?.image?.formats) {
    const { formats } = item.contentType.image;
    return formats.small ? formats.small.url : formats.thumbnail?.url ?? "";
  }
  return "";
};
